export const animatedHover = (color, thickness = 2, reverse) => ({
  textDecoration: "none !important",
  color: "inherit",
  position: "relative",
  ":after": {
    content: "''",
    position: "absolute",
    left: reverse ? "0%" : "50%",
    bottom: `-${thickness}px`,
    background: color || "#000",
    width: reverse ? "100%" : "0px",
    height: `${thickness}px`,
    transition: "all 500ms",
  },
  ":hover": {
    opacity: 0.65,
  },
  ":hover,:focus:after": {
    textDecoration: "none !important",
  },
  ":hover:after,:focus:after": {
    width: reverse ? "0%" : "100%",
    left: reverse ? "50%" : "0px",
  },
})
export const underline = (color, active = true) => ({
  textDecoration: "none !important",
  color: "inherit",
  position: "relative",
  ":after": {
    content: "''",
    position: "absolute",
    left: "0%",
    bottom: ["-3px", null, "-4px"],
    background: color || "#000",
    width: active ? "100%" : "0%",
    height: ["3px", null, "4px"],
    transition: "all 500ms",
  },
})
